import { render, staticRenderFns } from "./ProvisionsCreationModal.vue?vue&type=template&id=08e8d36c&"
import script from "./ProvisionsCreationModal.vue?vue&type=script&lang=js&"
export * from "./ProvisionsCreationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports